module.exports = __webpack_public_path__ + "media/static/icons/icon-legend-wind-38f2f15f75a6eb2f54fc0fa1898f0652.svg";